import { prefixObjectValues } from '../utils';

const typeAndCategory = {
  title: 'title',
  categoryDropdown: 'category-dropdown',
  typeDropdown: 'type-dropdown',
  firstName: 'first-name',
  lastName: 'last-name',
  npi: 'npi',
  nextButton: 'next-button',
  backButton: 'back-button',
  loadingBar: 'loading-bar',
  categoryError: 'category-error',
  typeError: 'type-error',
  firstNameError: 'first-name-error',
  lastNameError: 'last-name-error',
};

export default prefixObjectValues(typeAndCategory, 'registration-type-and-category');
